import IntroBlock, { BlockType } from 'components/public/Intro/IntroBlock';
import { Col, Divider } from 'antd';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import LastIntegrations from './LastIntegrations';

const ExampleLastIntegration = ({ type }: { type: BlockType }): JSX.Element => {
  const { formatMessage } = useIntl();

  return (
    <IntroBlock
      type={type}
      title={formatMessage({
        defaultMessage: 'Shopify - Teamleader',
        description: 'custom/examples/title',
      })}
      description={
        <Col>
          <p>
            <FormattedMessage
              defaultMessage="Check our off the shelve integration"
              description="custom/examples/description"
            />
          </p>
          <Divider />
          <LastIntegrations />
        </Col>
      }
    />
  );
};
export default ExampleLastIntegration;
